module.exports = __webpack_public_path__ + "static/media/admin-tools.6e1148f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/admin-tools.svg
// module id = 932
// module chunks = 0